import type { HeatmapCellData } from '@/data'
import { STATUS } from '@/enums'

export const getTextStatusColor = (status: STATUS) => {
  switch (status) {
    case STATUS.OPERATIONAL:
      return 'text-health-operational'
    case STATUS.DEGRADED:
      return 'text-health-degraded'
    case STATUS.OUTAGE:
      return 'text-health-outage'
    case STATUS.MAINTENANCE:
      return 'text-health-maintenance'
    default:
      return 'text-foreground/50'
  }
}

export const getBorderStatusColor = (status: STATUS) => {
  switch (status) {
    case STATUS.OPERATIONAL:
      return 'border-health-operational'
    case STATUS.DEGRADED:
      return 'border-health-degraded'
    case STATUS.OUTAGE:
      return 'border-health-outage'
    case STATUS.MAINTENANCE:
      return 'border-health-maintenance'
    default:
      return 'border-foreground/50'
  }
}

export const getBgStatusColor = (status: STATUS, dim = true) => {
  switch (status) {
    case STATUS.OPERATIONAL:
      return dim
        ? 'bg-health-operational/10 hover:bg-health-operational/20'
        : 'bg-health-operational'
    case STATUS.DEGRADED:
      return dim
        ? 'bg-health-degraded/10 hover:bg-health-degraded/20'
        : 'bg-health-degraded'
    case STATUS.OUTAGE:
      return dim
        ? 'bg-health-outage/10 hover:bg-health-outage/20'
        : 'bg-health-outage'
    case STATUS.MAINTENANCE:
      return dim
        ? 'bg-health-maintenance/10 hover:bg-health-maintenance/20'
        : 'bg-health-maintenance'
    default:
      return dim ? 'bg-foreground/10 hover:bg-foreground/20' : 'bg-foreground'
  }
}

export const getCellColor = (cell: HeatmapCellData): string => {
  switch (cell.status) {
    case 'up':
      return 'bg-health-operational/80 hover:bg-health-operational/100'
    case 'slow':
      return 'bg-health-degraded/80 hover:bg-health-degraded/100'
    case 'down':
      return 'bg-health-outage/80 hover:bg-health-outage/100'
    default:
      return 'bg-background-deep/60 hover:bg-foreground/20'
  }
}

export const getFillColor = (cell: HeatmapCellData): string => {
  switch (cell.status) {
    case 'up':
      return 'fill-health-operational/80 hover:fill-health-operational/100'
    case 'slow':
      return 'fill-health-degraded/80 hover:fill-health-degraded/100'
    case 'down':
      return 'fill-health-outage/80 hover:fill-health-outage/100'
    default:
      return 'fill-background-deep/60 hover:fill-foreground/20'
  }
}
